if (!customElements.get('mz-variant-dropdown')) {
  customElements.define(
    'mz-variant-dropdown',
    class MzVariantDropdown extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.selectedLabel = this.querySelector('[data-mz-selected-label]');
        this.selectedStatus = this.querySelector('[data-mz-selected-status]');
        this.optionButtons = Array.from(this.querySelectorAll('[data-mz-option]'));

        if (!this.select || !this.details || !this.selectedLabel) return;

        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.handleTriggerClick = this.handleTriggerClick.bind(this);
        this.handleNativeChange = this.syncSelectedState.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.optionButtons.forEach((button) => button.addEventListener('click', this.handleOptionClick));
        this.summary?.addEventListener('click', this.handleTriggerClick);
        this.select.addEventListener('change', this.handleNativeChange);
        this.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleDocumentClick);

        this.syncSelectedState();

        // Die alte Auswahl gibt es in dieser Kombination nicht (z. B. 908 g
        // bei einem Geschmack, der nur als 540 g existiert). Liquid hat den
        // ersten vorhandenen Wert vorausgewaehlt - jetzt die echte Variante
        // dazu laden, sonst bleibt "Nicht verfuegbar" stehen.
        if (this.hasAttribute('data-mz-ersatzwahl')) {
          this.removeAttribute('data-mz-ersatzwahl');
          setTimeout(() => {
            if (this.isConnected) this.select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }
      }

      disconnectedCallback() {
        this.optionButtons?.forEach((button) => button.removeEventListener('click', this.handleOptionClick));
        this.summary?.removeEventListener('click', this.handleTriggerClick);
        this.select?.removeEventListener('change', this.handleNativeChange);
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
      }

      handleOptionClick(event) {
        event.preventDefault();
        const button = event.currentTarget;

        if (!button?.dataset.mzValue) return;

        this.select.value = button.dataset.mzValue;
        this.syncSelectedState();
        this.details.open = false;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      handleTriggerClick(event) {
        event.preventDefault();
        const shouldOpen = !this.details.open;

        document.querySelectorAll('.mz-variant-dropdown__details[open]').forEach((details) => {
          if (details !== this.details) details.open = false;
        });

        this.details.open = shouldOpen;
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) this.details.open = false;
      }

      handleKeydown(event) {
        if (event.key !== 'Escape') return;
        this.details.open = false;
        this.details.querySelector('summary')?.focus();
      }

      syncSelectedState() {
        const selectedOption = this.select.selectedOptions[0];
        if (!selectedOption) return;

        const selectedButton = this.optionButtons.find((button) => button.dataset.mzValue === selectedOption.value);
        const selectedButtonLabel = selectedButton?.querySelector('[data-mz-option-label]')?.textContent.trim();
        const cleanNativeLabel = selectedOption.textContent
          .trim()
          .replace(/\s*[–-]\s*(nicht verfügbar|ausverkauft)\s*$/i, '');
        const isUnavailable = selectedButton?.dataset.mzAvailable === 'false';

        this.selectedLabel.textContent = selectedButtonLabel || cleanNativeLabel;
        if (this.selectedStatus) this.selectedStatus.hidden = !isUnavailable;

        this.optionButtons.forEach((button) => {
          const isSelected = button.dataset.mzValue === selectedOption.value;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
      }
    }
  );
}
